const { algoliasearch, instantsearch } = window;
console.log('AWP Instant Search Loaded');
const uniqueIndices = (awpsettings.indices || []).filter((idx, pos, arr)=>idx && idx.name && arr.findIndex((a)=>a && a.name === idx.name) === pos);
// first index
const fi = uniqueIndices[0] || {
    name: 'post',
    count: 5
};
function getSearchInstance(container) {
    const searchClient = algoliasearch(awpsettings.creds.application_id, awpsettings.creds.search_key);
    const search = instantsearch({
        indexName: 'post',
        searchClient,
        future: {
            preserveSharedStateOnUnmount: true
        },
        debug: false,
        insights: true,
        searchFunction: (helper)=>{
            const blacklist = [
                'vipreg',
                '/index/\\think\\app/invokefunction'
            ];
            const searchQuery = helper.state.query.trim();
            if (searchQuery.length < 1) return;
            const isBlacklisted = blacklist.some((item)=>{
                const regex = new RegExp(item, 'i'); // 'i' makes it case-insensitive
                return regex.test(searchQuery);
            });
            if (isBlacklisted) return;
            helper.search();
        }
    });
    $(container + ' .algolia-' + fi.name).show();
    search.addWidgets([
        instantsearch.widgets.searchBox({
            container: container + ' .searchbox',
            placeholder: 'Search'
        }),
        instantsearch.widgets.configure({
            hitsPerPage: fi.count
        }),
        instantsearch.widgets.pagination({
            container: container + ' .pagination',
            padding: 1
        })
    ]);
    $(($1)=>{
        $1(uniqueIndices).each((i, e)=>{
            $1(container + ' .algolia-' + e.name).show();
            const index = instantsearch.widgets.index({
                indexName: e.name
            });
            index.addWidgets([
                instantsearch.widgets.configure({
                    hitsPerPage: e.count
                }),
                instantsearch.widgets.hits({
                    container: container + ' .' + e.name + '-hits',
                    transformItems: (items)=>{
                        const seen = new Set();
                        return items.filter((item)=>{
                            const key = `${item.permalink || ''}|${item.post_title || ''}`;
                            if (seen.has(key)) return false;
                            seen.add(key);
                            return true;
                        });
                    },
                    templates: {
                        item: (hit, { html, components })=>{
                            const snippetPriority = [
                                'post_content',
                                'post_excerpt',
                                'content',
                                'body_copy',
                                'headline',
                                'modules_0_wysiwyg'
                            ];
                            const stripHtml = (value)=>(value || '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;/gi, ' ').replace(/\s+/g, ' ').trim();
                            const decodeHtmlEntities = (value)=>{
                                const txt = document.createElement('textarea');
                                txt.innerHTML = value || '';
                                return txt.value || '';
                            };
                            const fieldValue = snippetPriority.map((key)=>hit[key]).find((value)=>typeof value === 'string' && value.trim().length > 0) || '';
                            let snippetValue = '';
                            if (typeof hit._snippetResult !== 'undefined') {
                                const snippetKey = snippetPriority.find((key)=>Object.prototype.hasOwnProperty.call(hit._snippetResult, key)) || Object.keys(hit._snippetResult)[0] || '';
                                snippetValue = snippetKey && hit._snippetResult[snippetKey] && typeof hit._snippetResult[snippetKey].value === 'string' ? hit._snippetResult[snippetKey].value : '';
                            }
                            const summary = stripHtml(decodeHtmlEntities(fieldValue || snippetValue));
                            const excerpt = summary.length > 180 ? summary.substring(0, 177) + "\u2026" : summary;
                            return html`
                <article>
                  <a href="${hit.permalink}" title="${hit.post_title || ''}">
                    <div class="img-wrap">
                      <img
                        src="${hit.thumbnail}"
                        height="50"
                        width="50"
                        alt="${hit.post_title}"
                      />
                    </div>
                    <div id="txt-wrap">
                      <span class="h4 algolia-post-title">
                        ${components.Highlight({
                                hit,
                                attribute: 'post_title'
                            })}
                      </span>
                      <p>
                        ${excerpt}
                        <em>read more</em>
                      </p>
                    </div>
                  </a>
                </article>
              `;
                        }
                    }
                })
            ]);
            search.addWidgets([
                index
            ]);
        });
    });
    return search;
}
var instances = [];
if ($('.when-unstuck').length) {
    var searcha = getSearchInstance('.when-unstuck');
    searcha.start();
}
if ($('.when-stuck').length) {
    var searchb = getSearchInstance('.when-stuck');
    searchb.start();
}
if ($('.body-search').length) {
    var searchc = getSearchInstance('.body-search');
    searchc.start();
}
if ($('.mobile-search').length) {
    var searchd = getSearchInstance('.mobile-search');
    searchd.start();
    $(document).on('click', '#ssme-search', ()=>{
        $('.mobile-search').toggle();
        $('.mobile-header-wrapper > .container > .row:first-child').toggle();
        $('.mobile-search .ais-SearchBox-input').focus();
    });
}
if ($('.mobile-nav-search').length) {
    var searche = getSearchInstance('.mobile-nav-search');
    searche.start();
}
$(document).on('click', '.ais-SearchBox-reset', ()=>{
    $('.mobile-search').toggle();
    $('.mobile-header-wrapper > .container > .row:first-child').toggle();
});
$('.searchbox').on('keyup', (ev)=>{
    if (ev.target.value.trim().length > 0) $(ev.currentTarget).siblings('.results').show();
});
$('.searchbox').on('keydown', (ev)=>{
    if (ev.key === 'Enter' || ev.keyCode === 13) window.location.href = '/?s=' + $(ev.target).val();
});
$(document).on('click', (ev)=>{
    if (!$(ev.target).closest('.algolia-with-wordpress.dropdown').length) $('.results').hide();
});
if (typeof searcha != 'undefined') searcha.on('render', ()=>{
    $('.when-unstuck .results > div').show();
    $('#noResults').remove();
    $('.when-unstuck .ais-Hits--empty').parent().parent().hide();
    if ($('.when-unstuck .ais-Hits-item:visible').length < 1) $('.when-unstuck .pagination').before("<p id='noResults'>no results</p>");
});
if (typeof searchb != 'undefined') searchb.on('render', ()=>{
    $('.when-stuck .results > div').show();
    $('#noResults').remove();
    $('.when-stuck .ais-Hits--empty').parent().parent().hide();
    if ($('.ais-Hits-item:visible').length < 1) $('.when-stuck .pagination').before("<p id='noResults'>no results</p>");
});
if (typeof searchc != 'undefined') searchc.on('render', ()=>{
    $('.body-search .results > div').show();
    $('#noResults').remove();
    $('.body-search .ais-Hits--empty').parent().parent().hide();
    if ($('.ais-Hits-item:visible').length < 1) $('.body-search .pagination').before("<p id='noResults'>no results</p>");
});
if (typeof searchd != 'undefined') searchd.on('render', ()=>{
    $('.mobile-search .results > div').show();
    $('#noResults').remove();
    $('.mobile-search .ais-Hits--empty').parent().parent().hide();
    if ($('.ais-Hits-item:visible').length < 1) $('.body-search .pagination').before("<p id='noResults'>no results</p>");
});
if (typeof searche != 'undefined') searche.on('render', ()=>{
    $('.mobile-nav-search .results > div').show();
    $('#noResults').remove();
    $('.mobile-nav-search .ais-Hits--empty').parent().parent().hide();
    if ($('.ais-Hits-item:visible').length < 1) $('.mobile-nav-search .pagination').before("<p id='noResults'>no results</p>");
});

//# sourceMappingURL=instant-search.9405de75.js.map
